<template>
  <div>
    <b-alert variant="info" show class="mb-2">
      <div class="alert-body">
        A região de atuação é o que coloca na busca quem não tem endereço comercial.
        Guarde bairro e cidade — <strong>nunca o endereço residencial do profissional</strong>,
        que não é publicado.
      </div>
    </b-alert>

    <div class="vx-row mb-4">
      <div class="vx-col sm:w-1/4 w-full">
        <b-form-group label="Raio de atendimento (km)" label-for="service_radius_km">
          <b-form-input
            id="service_radius_km"
            v-model="professional.service_radius_km"
            type="number"
            min="0"
            name="service_radius_km"/>
        </b-form-group>
      </div>
      <div class="vx-col sm:w-3/4 w-full flex items-end">
        <b-button variant="primary" class="mb-1" @click="$emit('save-radius')">
          Salvar raio de atendimento
        </b-button>
      </div>
    </div>

    <validation-observer ref="serviceAreaForm">
      <b-form @submit.prevent="save">
        <div class="vx-row">
          <div class="vx-col sm:w-1/4 w-full">
            <b-form-group label="Estado" label-for="federation_unit">
              <v-select
                id="federation_unit"
                :options="federationUnitList"
                label="name"
                v-model="federationUnit"
                @input="loadCities">
                <div slot="no-options">Nenhum registro encontrado!</div>
              </v-select>
            </b-form-group>
          </div>
          <div class="vx-col sm:w-1/4 w-full">
            <b-form-group label="Cidade" label-for="city">
              <validation-provider #default="{ errors }" name="Cidade" rules="required">
                <v-select
                  id="city"
                  :options="cityList"
                  label="name"
                  v-model="area.city"
                  :disabled="!federationUnit">
                  <div slot="no-options">Nenhum registro encontrado!</div>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
          <div class="vx-col sm:w-1/4 w-full">
            <b-form-group label="Bairro" label-for="district_name">
              <b-form-input id="district_name" v-model="area.district_name" name="district_name"/>
            </b-form-group>
          </div>
          <div class="vx-col sm:w-1/4 w-full">
            <b-form-group label="Região principal">
              <b-form-checkbox v-model="area.head" class="mt-1">
                Usar como referência na busca
              </b-form-checkbox>
            </b-form-group>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col sm:w-1/4 w-full">
            <b-form-group label="Latitude" label-for="latitude">
              <b-form-input id="latitude" v-model="area.latitude" name="latitude"/>
            </b-form-group>
          </div>
          <div class="vx-col sm:w-1/4 w-full">
            <b-form-group label="Longitude" label-for="longitude">
              <b-form-input id="longitude" v-model="area.longitude" name="longitude"/>
            </b-form-group>
          </div>
          <div class="vx-col sm:w-1/2 w-full flex items-end">
            <b-button variant="primary" type="submit" :disabled="!area.city" class="mb-1">
              {{ area.id ? 'Alterar' : 'Adicionar' }}
            </b-button>
            <b-button variant="outline-secondary" @click="resetForm" class="mb-1 ml-2" v-if="area.id">
              Cancelar
            </b-button>
          </div>
        </div>
        <small class="text-muted d-block mb-2">
          Deixe as coordenadas em branco para herdar as da cidade quando forem confiáveis.
        </small>
      </b-form>
    </validation-observer>

    <div class="vx-row mt-4 mb-10">
      <div class="vx-col w-full">
        <vs-table :data="areaList" no-data-text="Nenhuma região cadastrada">
          <template slot="thead">
            <vs-th>Cidade</vs-th>
            <vs-th>Bairro</vs-th>
            <vs-th>Principal</vs-th>
            <vs-th>Ação</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{ cityNameOf(data[indextr]) }}</vs-td>
              <vs-td>{{ data[indextr].district_name }}</vs-td>
              <vs-td>
                <feather-icon
                  v-if="data[indextr].head"
                  icon="CheckIcon"
                  class="h-5 w-5 stroke-current text-success"/>
              </vs-td>
              <vs-td>
                <div class="flex flex-row gap-2">
                  <feather-icon
                    icon="EditIcon"
                    style="cursor: pointer;"
                    class="h-5 w-5 mr-1 stroke-current"
                    @click="edit(data[indextr])"/>
                  <feather-icon
                    icon="Trash2Icon"
                    style="cursor: pointer;"
                    class="h-5 w-5 mr-1 stroke-current text-danger"
                    @click="destroy(data[indextr])"/>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BForm, BButton, BFormInput, BFormGroup, BFormCheckbox, BAlert } from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BFormCheckbox,
    BAlert,
    ValidationProvider,
    ValidationObserver
  },
  props: {
    legalEntityId: {
      type: Number,
      default: null
    },
    professional: {
      type: Object,
      default: () => ({})
    },
    services: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    federationUnit: null,
    federationUnitList: [],
    cityList: [],
    areaList: [],
    area: {
      id: null,
      city: null,
      district_name: null,
      latitude: null,
      longitude: null,
      head: false,
    },
  }),
  methods: {
    loadList() {
      if (!this.legalEntityId) return

      this.services.legalEntityService.getServiceAreas(this.legalEntityId).then(
        data => { this.areaList = data },
        () => {}
      )
    },
    loadCities(federationUnit) {
      this.cityList = []
      this.area.city = null

      if (!federationUnit) return

      this.services.federationUnitService.findAllCitiesByFederationUnity(federationUnit.id).then(
        data => { this.cityList = data },
        () => {}
      )
    },
    cityNameOf(area) {
      return this._.get(area, 'city.name', '')
    },
    save() {
      this.$refs.serviceAreaForm.validate().then(success => {
        if (!success || !this.area.city) return

        this.$vs.loading()
        this.services.legalEntityService.saveServiceArea(this.legalEntityId, {
          id: this.area.id,
          city_id: this.area.city.id,
          district_name: this.area.district_name,
          latitude: this.area.latitude || null,
          longitude: this.area.longitude || null,
          head: !!this.area.head,
        }).then(
          () => {
            this.$vs.loading.close()
            this.notifySuccess(this.$vs)
            this.resetForm()
            this.loadList()
          },
          error => {
            this.$vs.loading.close()
            this.showErrors(this.$refs.serviceAreaForm, error)
          }
        )
      })
    },
    edit(area) {
      this.area = {
        id: area.id,
        city: area.city,
        district_name: area.district_name,
        latitude: area.latitude,
        longitude: area.longitude,
        head: area.head,
      }
      // A cidade já vem resolvida do backend, então a lista serve só para trocar.
      this.cityList = area.city ? [area.city] : []
    },
    destroy(area) {
      this.$vs.loading()
      this.services.legalEntityService.deleteServiceArea(this.legalEntityId, area.id).then(
        () => {
          this.$vs.loading.close()
          this.notifySuccess(this.$vs)
          this.loadList()
        },
        error => {
          this.$vs.loading.close()
          this.showErrors(this.$refs.serviceAreaForm, error)
        }
      )
    },
    resetForm() {
      this.area = { id: null, city: null, district_name: null, latitude: null, longitude: null, head: false }
      this.federationUnit = null
      this.cityList = []
    },
  },
  mounted() {
    this.loadList()

    this.services.federationUnitService.all().then(
      data => { this.federationUnitList = data },
      () => {}
    )
  }
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
